import lotsButton from './index.vue';

lotsButton.install = (Vue) => {
    Vue.component(lotsButton.name, lotsButton);
};
export default lotsButton;
